function clearCartOnProductPage() {
  console.log('🟡 Intentando limpiar carrito desde página de producto');

  fetch('/cart/clear.js', { method: 'POST' })
    .then(() => {
      console.log('🧹 Carrito vaciado correctamente');
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
    })
    .catch(error => {
      console.error('❌ Error al vaciar el carrito:', error);
    });
}

document.addEventListener('DOMContentLoaded', function () {
  clearCartOnProductPage();
});

window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    console.log('🔄 Página restaurada desde caché. Volviendo a vaciar el carrito.');
    clearCartOnProductPage();
  }
});
